"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonNotPursued = exports.JudgmentAction = exports.DefaultReason = exports.ClaimBorrowerType = exports.ClaimBorrowerCategory = void 0;
var ClaimBorrowerCategory;
(function (ClaimBorrowerCategory) {
    ClaimBorrowerCategory[ClaimBorrowerCategory["Covenantor"] = 1] = "Covenantor";
    ClaimBorrowerCategory[ClaimBorrowerCategory["Guarantor"] = 2] = "Guarantor";
})(ClaimBorrowerCategory = exports.ClaimBorrowerCategory || (exports.ClaimBorrowerCategory = {}));
var ClaimBorrowerType;
(function (ClaimBorrowerType) {
    ClaimBorrowerType[ClaimBorrowerType["Borrower"] = 1] = "Borrower";
    ClaimBorrowerType[ClaimBorrowerType["CoBorrower"] = 2] = "CoBorrower";
})(ClaimBorrowerType = exports.ClaimBorrowerType || (exports.ClaimBorrowerType = {}));
var DefaultReason;
(function (DefaultReason) {
    DefaultReason[DefaultReason["IllnessOrDeathOfTheBorrower"] = 1] = "IllnessOrDeathOfTheBorrower";
    DefaultReason[DefaultReason["MaritalOrRelationshipBreakdown"] = 2] = "MaritalOrRelationshipBreakdown";
    DefaultReason[DefaultReason["Unemployment"] = 3] = "Unemployment";
    DefaultReason[DefaultReason["LossOfIncome"] = 4] = "LossOfIncome";
    DefaultReason[DefaultReason["Strike"] = 5] = "Strike";
    DefaultReason[DefaultReason["Misrepresentation"] = 6] = "Misrepresentation";
    DefaultReason[DefaultReason["Other"] = 7] = "Other";
})(DefaultReason = exports.DefaultReason || (exports.DefaultReason = {}));
var JudgmentAction;
(function (JudgmentAction) {
    JudgmentAction["Settlement"] = "01";
    JudgmentAction["Obtained"] = "02";
    JudgmentAction["Ongoing"] = "03";
    JudgmentAction["NotPursued"] = "04";
    JudgmentAction["Bankrupt"] = "05";
})(JudgmentAction = exports.JudgmentAction || (exports.JudgmentAction = {}));
var ReasonNotPursued;
(function (ReasonNotPursued) {
    ReasonNotPursued[ReasonNotPursued["UnableToLocateTheBorrower"] = 1] = "UnableToLocateTheBorrower";
    ReasonNotPursued[ReasonNotPursued["CollectionProspectIsPoorForCMHC"] = 2] = "CollectionProspectIsPoorForCMHC";
    ReasonNotPursued[ReasonNotPursued["NotWorthPursuingTheJudgment"] = 3] = "NotWorthPursuingTheJudgment";
    ReasonNotPursued[ReasonNotPursued["ProvincialLegislation"] = 4] = "ProvincialLegislation";
    ReasonNotPursued[ReasonNotPursued["Other"] = 5] = "Other";
})(ReasonNotPursued = exports.ReasonNotPursued || (exports.ReasonNotPursued = {}));
